<div class="flex-layout center-content">
  <div class="ops-header item-grow">
    <a routerLink="/operational-dashboard/upcoming-orders-with-missing-content">Upcoming Orders with Missing Content</a>
  </div>
</div>

@if (isLoading) {
  <insight-loading-spinner
    loadingMessage="Loading...">
  </insight-loading-spinner>
}

<div class="content-box-content" style="padding: 1rem;" [hidden]="isLoading || didError">
  <mat-table [dataSource]="upcomingOrdersWithMissingContent" matSort>
    <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
    <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>

    <!-- Title Column -->
    <ng-container matColumnDef="title">
      <mat-header-cell *matHeaderCellDef mat-sort-header>Title</mat-header-cell>
      <mat-cell *matCellDef="let missingContent">
        <label style="word-break: break-word;">
          {{missingContent.title}}
        </label>
      </mat-cell>
    </ng-container>

    <!-- Orders Column -->
    <ng-container matColumnDef="orders">
      <mat-header-cell *matHeaderCellDef mat-sort-header>Orders</mat-header-cell>
      <mat-cell *matCellDef="let missingContent">
        <label style="word-break: break-word;">{{missingContent.orders}}</label>
      </mat-cell>
    </ng-container>

    <!-- Next Due Date Column -->
    <ng-container matColumnDef="nextDueDateTime">
      <mat-header-cell *matHeaderCellDef mat-sort-header>Next Due Date</mat-header-cell>
      <mat-cell *matCellDef="let missingContent">
        <label style="word-break: break-word;">{{missingContent.nextDueDateTime | date: 'shortDate'}}</label>
      </mat-cell>
    </ng-container>

  </mat-table>
</div>

@if (!isLoading && didError) {
  <div class="flex-layout center-content">
    <div>
      An error occurred while getting orders by shipment.
    </div>
  </div>
}
